export default __webpack_public_path__ + "9102505a8f0214aacea6302ff7b94ca7.svg";